import { CloudFullLogoSVG, CloudLogoSVG } from '@sbercloud/uikit-product-icons';
import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import { ButtonFunction } from '@snack-uikit/button';
import { Typography } from '@snack-uikit/typography';
import Link from 'next/link';

import { useAppNavigationCtx, useServerDataCtx } from '@/hooks/ctx';
import { useCurrentPlatform } from '@/hooks/useCurrentPlatform';
import { useLayoutType } from '@/hooks/useLayoutType';
import s from '@/layout/Header/styles.module.scss';
import { getGlobalArgs } from '@/root/global';
import { isLargeThan } from '@/utils/layout';
import { getActiveAppNavigationItem } from '@/utils/navigation';

export function LogoWithDocs() {
  const { headers } = useServerDataCtx();
  const platform = useCurrentPlatform();
  const { appNavigationConfig } = useAppNavigationCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);
  const logo = isLargeThan('mobile', layoutType) ? (
    <CloudFullLogoSVG className={s.logoIcon} />
  ) : (
    <CloudLogoSVG size={24} />
  );

  const activeAppNavigationItem = getActiveAppNavigationItem(appNavigationConfig, platform, 'name');

  return (
    <div className={s.logo}>
      <a href={getGlobalArgs('NEXT_PUBLIC_CONTENT_BASE_URL', 'cloud.ru')} className={s.logoLink}>
        {logo}
      </a>

      <Link href={activeAppNavigationItem ? activeAppNavigationItem.path : '/'} passHref legacyBehavior>
        <ButtonFunction
          // @ts-ignore
          label={<Typography.SansTitleM> / DOCS</Typography.SansTitleM>}
          size='l'
          appearance='neutral'
          target='_self'
        />
      </Link>
    </div>
  );
}
